import apiCallTemplate from './config'
import credentials from '../assets/credentials'

const {BASE_URL}=credentials
const notificationURL = `${BASE_URL}/notifications`;


//all notifications
export const AllNotifications=async (query)=>apiCallTemplate("get", `${notificationURL}${query}`)

//new notifications counter -user
export const newNotificationCounter=async ()=>apiCallTemplate("get", `${notificationURL}/user/new`)

//new notifications counter -admin
export const newNotificationCounterAdmin=async ()=>apiCallTemplate("get", `${notificationURL}/admin/new`)

//Get notification by id
export const getnotificationById=async (id)=>apiCallTemplate("get", `${notificationURL}/${id}`)
